module.exports = __webpack_public_path__ + "img/Banner150.410befd1.png";